import { useFetch } from './useFetch'

export const useAnuncioService = () => {
  const fetch = useFetch()

  const cadastrarAnuncioAsync = async (dados, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const dadosAnuncio = {
        titulo: dados.titulo,
        destino: dados.destino,
        destinoSelecionado: dados.destinoSelecionado?.map((destino) => destino.id) || null,
        resumo: dados.resumo,
        conteudo: dados.conteudo,
      }
      await fetch.postOpen('/anuncios', dadosAnuncio)
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const listarAnunciosAsync = async (limit, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(`/anuncios/visualizar/${limit}`)
      return response.data.anuncios
    } catch (err) {
      return null
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const listarAnuncioAsync = async (id, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(`/anuncios/${id}`)
      return response.data.anuncio
    } catch (err) {
      return null
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }
  return {
    cadastrarAnuncioAsync,
    listarAnunciosAsync,
    listarAnuncioAsync,
  }
}
